<template>
  <v-app>
    <v-main>
      <l-map ref="myMap" style="height: 100%; z-index: 100;" :zoom="zoom" :center="center">
        <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
        <!--<l-marker v-for="device in getDevicesData" :key="device.id" :lat-lng="[device.address.latitude, device.address.longitude]" @click="markerClick(device)">
          <l-tooltip>
            ID: DVC {{`000${device.id}`.substring(`000${device.id}`.length-3, `000${device.id}`.length)}}
            <br/>
            Name: {{ device.name }}
          </l-tooltip>
        </l-marker>-->
      </l-map>
      <router-view/>
      <v-dialog
        v-model="loadingDialog"
        content-class="custom-loading-dialog"
        persistent
      >
        <div class="text-center">
          <v-progress-circular
            :size="70"
            :width="3"
            color="dark"
            indeterminate
          ></v-progress-circular>
        </div>
      </v-dialog>
      <MarkerClick :device="selectedDevice" :isShowDialog="isMarkerClick" @HideMarkerClick="isMarkerClick = false"></MarkerClick>
    </v-main>
  </v-app>
</template>

<script>
import L from 'leaflet'
import Markercluster from 'leaflet.markercluster'
import MarkerClick from './views/modals/MarkerClick'
import ErrorCodes from './Enums/errorCodes'
import axiosService from "./services/axiosService"
import storageService from "./services/storageService"
import {mapGetters, mapActions, mapMutations, mapState} from 'vuex'
export default {
  name: 'App',
  components: {
    MarkerClick
  },
  data(){
    return {
      markers: null,
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png?lang=en',
      attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 30,
      markerBuffer: [],
      center: [47.227941, 39.716729],
      selectedDevice: null,
      isMarkerClick: false,
      devices:[
        {
          id: 1,
          LatLng: [47.227941, 39.716729]
        }
      ],
      checkCurrentRouteName(location) {
        return this.$route.path == location
      },
      goToAccount(){
        if(this.$route.path != '/'  && this.$route.path != '/Login'){
          return true
        }
        return false
      },
      loadingDialog: false
    }
  },
  computed:{
    ...mapGetters(['getDevicesData', 'getDeviceTypes', 'getDeviceMapState']),
    matchPanelSize(){
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '100%'
        case 'sm': return '80%'
        case 'md': return '70%'
        case 'lg': return '50%'
        case 'xl': return '35%'
      }
    }
  },
  methods: {
    ...mapActions(['getSubjectCreationData','loginUserByToken', 'getDevices', 'getDeviceTypesAction', 'getSubDeviceTypesAction']),
    ...mapMutations(['saveAccessToken', 'resetState', 'allLoad', 'updateDeviceGps', 'selectDevice']),
    markerClickFind(device){
      /*console.log(this.markerBuffer.filter(d => d.deviceId == device.deviceId)[0].marker.__parent.getChildCount())
      this.markerBuffer.filter(d => d.deviceId == device.deviceId)[0].marker.__parent.spiderfy()*/
      this.markerClick(device)
    },
    markerClick(device){
      /*console.log(this.$refs.myMap)
      console.log(this.$refs.myMap.mapObject)
      this.markerBuffer.filter(d => d.deviceId == device.deviceId)[0].marker.openPopup()
      console.log(this.markerBuffer.filter(d => d.deviceId == device.deviceId)[0].marker._icon)*/
      //this.markerBuffer.filter(d => d.deviceId == device.deviceId)[0].marker.click();
      this.markerBuffer.forEach(d => {
        //d.marker.__parent.unspiderfy()
      })
      /*console.log(this.markers)
      console.log(this.markerBuffer.filter(d => d.deviceId == device.deviceId)[0].marker._leaflet_id)
      console.log(this.markerBuffer.filter(d => d.deviceId == device.deviceId)[0].marker)
      this.openMarkerClustersAndMarkerPopup(this.markers, this.markerBuffer.filter(d => d.deviceId == device.deviceId)[0].marker._leaflet_id)
      //this.markers._events.clusterclick[0].fn(this.markerBuffer.filter(d => d.deviceId == device.deviceId)[0].marker)
      //this.markerBuffer.filter(d => d.deviceId == device.deviceId)[0].marker._events.click['0'].fn()
      return
      */
      console.log(device)
      this.getDevicesData.forEach(dev => {
        if(dev.id == device.id){
          device = dev
        }
      })
      this.center = [device.address.latitude, device.address.longitude]
      this.$refs.myMap.mapObject.panTo([device.address.latitude, device.address.longitude])
      this.selectedDevice = device
      this.selectDevice(this.selectedDevice)
      this.isMarkerClick = true
    },  
    logOut(){
      this.resetState()
      storageService.removeAll()
      this.$router.push('Login').catch(() => {})
    },
    async reMountApp(){
      this.$nextTick(() => {
        this.$refs.myMap.mapObject.attributionControl.setPrefix(false)
        this.$refs.myMap.mapObject.removeControl(this.$refs.myMap.mapObject.zoomControl)
        this.$root.$on('globalError', (data) => {
          console.log(data)
          if(ErrorCodes[data] == undefined){
            this.$noty.error(data).setTimeout(2500)
          }else{
            this.$noty.error(ErrorCodes[data]).setTimeout(2500)
          }
        })
        this.$root.$on('loading', (state) => {
          if(state == 'start'){
            this.loadingDialog = true
          }else if(state == 'end'){
            this.loadingDialog = false
          }
        })
      })
      
      if(axiosService.tryRestoreAccessToken()){
        try{
          const result = await this.loginUserByToken()
          console.log(result)
          this.saveAccessToken(storageService.getToken())
          if(result.result.code == 0){
            //await this.getDevices()
            this.$router.push(storageService.getTryLocation()).catch(() => {})
          }else{
            storageService.removeAll()
            this.resetState()
            this.$router.push('Login').catch(() => {})
          }
        }catch(e){
          console.log(e)
          storageService.removeAll()
          this.resetState()
          this.$router.push('Login').catch(() => {})
        }
        
        await this.getDeviceTypesAction()
        await this.getSubDeviceTypesAction()
        await this.getSubjectCreationData()
        await this.getDevices()
        .then(res => {
          if(res.subjects.length > 0){
            console.log(res.subjects[0].address)
            this.center = [res.subjects[0].address.latitude, res.subjects[0].address.longitude]
            this.$refs.myMap.mapObject.panTo([res.subjects[0].address.latitude, res.subjects[0].address.longitude])
            this.mountMap()
          }
        })
      }
    },
    mountMap(){
      this.markerBuffer = []
      this.markers = L.markerClusterGroup({
        zoomToBoundsOnClick: true
      });
      this.markers.on('clusterclick', function (a) {
        a.layer.zoomToBounds({padding: [20, 20]});
      });
      this.getDevicesData.forEach(device => {
        const marker = new L.marker([device.address.latitude, device.address.longitude])
        .on('click', () => {
          this.markerClick(device)
        })
        marker.bindTooltip(`ID: DVC`+`000${device.id}`.substring(`000${device.id}`.length-3, `000${device.id}`.length)+'<br/>'+`Name: ${device.name}`)
        console.log(marker)
        this.markerBuffer.push({
          deviceId: device.deviceId,
          marker: marker
        })
        console.log(this.markerBuffer)
        //marker.on('click', this.markerClick(device))
        this.markers.addLayer(marker);
      })
      /*markers.on('click', (tt) => {
        console.log(tt)
      })*/
      
      this.$refs.myMap.mapObject.addLayer(this.markers)
      console.log(this.$refs.myMap.mapObject)
    }
  },
  async mounted() {
    await this.reMountApp()
    this.$root.$on("refreshDevices", async () => {
      await this.getDevices()
      .then(res => {
        if(res.subjects.length > 0){
          console.log(res.subjects[0].address)
          this.center = [res.subjects[0].address.latitude, res.subjects[0].address.longitude]
          this.$refs.myMap.mapObject.panTo([res.subjects[0].address.latitude, res.subjects[0].address.longitude])
        }
      })
    })
    this.$root.$on("reMountApp", async () => {
      await this.reMountApp()
    })
    this.$root.$on("markerClick", (device) => {
      console.log('markerClick App.vue')
      this.markerClickFind(device)
    })
    this.$root.$on('HideMarkerClick', () => {
      this.isMarkerClick = false
    })
    this.$root.$on("ReMountMapByHub", async () => {
      if(this.getDeviceMapState!= null) this.getDeviceMapState.forEach(updateMapInfo => {
        this.getDevicesData.forEach(device => {
          if(updateMapInfo.DeviceId == device.deviceId){
            this.updateDeviceGps(updateMapInfo)
            console.log(this.markerBuffer.filter(d => d.deviceId == device.deviceId))
            console.log(this.markerBuffer)
            this.markerBuffer.filter(d => d.deviceId == device.deviceId)[0].marker.setLatLng([updateMapInfo.Latitude, updateMapInfo.Longitude]).update();
          }
        })
      })
    })
  },
};
</script>
<style lang="scss">
  @import './src/styles/variables.scss';
  .v-date-picker-table table tbody tr:hover{
    background-color: #FFF !important
  }
  .v-picker__title{
    color: #000 !important;
  }
  .v-input--is-disabled{
    border-color: rgba(255,255,255, 0.5) !important; 
    color: rgba(255,255,255, 0.5) !important;
  }
  html{
    overflow-y:hidden !important;
  }
  .position-absolute{
    position: absolute;
  }
  .noty_body{
    font-size: 0.875rem;
    font: inherit;
  }
  .custom-loading-dialog{
    z-index: 10013; box-shadow: none !important; overflow-y:hidden !important;
  }
  .theme--light.v-card {
    background-color: rgba(0, 0, 255, 0.75) !important;
  } 
  .theme--light.v-input input, .theme--light.v-input textarea {
    color: rgba(255, 255, 255, 0.87);
  }
  .theme--light.v-sheet {
    background-color: #FFFFFF;
    border-color: #FFFFFF;
    color: rgba(255, 255, 255, 0.87);
  }
  .theme--light.v-card > .v-card__text, .theme--light.v-card > .v-card__subtitle {
    color: rgba(255, 255, 255, 0.87);
}
.v-overlay__scrim{
  background-color: rgba(0,0,0,0) !important;
}
.theme--light.v-label {
    color: rgba(255, 255, 255, 0.87);
}
.v-text-field--outlined{
  margin-top: 0px !important;
}
.v-text-field--outlined fieldset{
  border-color: #FFFFFF;
}
.v-input--is-disabled fieldset{
  border-color: rgba(255, 255, 255, 0.67);
  color: rgba(255, 255, 255, 0.67);
}
.theme--light.v-input--is-disabled {
  color: rgba(255, 255, 255, 0.67);
}
.modal_button,.v-list{
  color: white !important;
  background-color: rgba(0, 0, 255, 0.75) !important;
}
.v-icon, .v-list-item__title, .v-select__selection {
  color: white !important;
}
.v-btn, .v-data-table{
  border-color: #FFFFFF !important;
  color: #FFFFFF !important;
  background-color: rgba(0, 0, 255, 0.75) !important;
}
tr:hover{
  
  background-color: rgba(0, 0, 255, 0.55) !important;
}
input:-internal-autofill-selected {
    background-color: rgba(0, 0, 255, 0.75) !important;
}
.color-white{
  color: white !important;
}
.v-application {
  caret-color: white !important;
}
.v-input--is-focused{
  border-color: #FFFFFF !important;
  color: #FFFFFF !important;
  background-color: rgba(0, 0, 255, 0.75) !important;
}
.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th{
  color: #FFFFFF !important;
}
.v-label, .v-card__title{
  color: #FFFFFF !important;
}
.v-text-field__slot > input {
  color:  #FFFFFF !important;
}
.theme--light.v-btn.v-btn--disabled{
  border-color: rgba(255,255,255, 0.5) !important; 
  color: rgba(255,255,255, 0.5) !important;
}
.theme--light.v-input--is-disabled > .v-input__control{
  border-color: rgba(255,255,255, 0.5) !important; 
  color: rgba(255,255,255, 0.5) !important;
}
.theme--light.v-icon.v-icon.v-icon--disabled{
  color: rgba(255,255,255, 0) !important;
}
.v-select__selection--disabled{
  color: rgba(255,255,255, 0.5) !important;
}

input:-webkit-autofill,
input:-webkit-autofill:hover, 
input:-webkit-autofill:focus
input:-webkit-autofill, 
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  transition: background-color 5000s ease-in-out 0s;
  background: #000 !important;  
  color: #fff !important;
}
</style>